import React from 'react';
import styles from '../styles/stepCommon.module.css';

interface StepLoginPromptProps {
  onLogin: () => void;
}

/**
 * Unified login prompt for all 12 step pages.
 * Covers: new users, expired sessions, and users arriving from bookmarks.
 */
const StepLoginPrompt: React.FC<StepLoginPromptProps> = ({ onLogin }) => (
  <div className={styles.loginPrompt}>
    <div className={styles.loginPromptContent}>
      <p>
        Sign in if you already have an account or create an account to track your progress.
      </p>
      <div className={styles.loginPromptButtonGroup}>
        <button onClick={onLogin} className={styles.loginPromptLoginButton}>
          Sign in
        </button>
        <button onClick={onLogin} className={styles.loginPromptCreateAccountButton}>
          Create Account
        </button>
      </div>
    </div>
  </div>
);

export default StepLoginPrompt;
